module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "account-right-item attention"
  }, [_c('h4', [_vm._v("我关注的: "), _c('span', [_vm._v(_vm._s(_vm.attention_num) + "人")])]), _vm._v(" "), (_vm.page.total != 0) ? _c('div', [_c('ul', {
    staticClass: "wrapper-list clearfix"
  }, _vm._l((_vm.attention_list), function(item) {
    return _c('li', {
      staticClass: "clearfix"
    }, [_c('a', {
      staticClass: "fl images-box",
      attrs: {
        "href": "javascript:;"
      }
    }, [(item.avatar_url.indexOf('?') !== 0) ? _c('img', {
      attrs: {
        "src": item.avatar_url,
        "alt": "",
        "width": "60",
        "height": "60"
      }
    }) : _c('img', {
      attrs: {
        "src": require("../../../images/personal_center/avatar_default.png"),
        "alt": "",
        "width": "60",
        "height": "60"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "fl info-box"
    }, [_c('a', {
      attrs: {
        "href": "javascript:;"
      }
    }, [_c('h5', {
      staticClass: "toe",
      attrs: {
        "title": item.nick_name
      }
    }, [_vm._v(_vm._s(item.nick_name))])]), _vm._v(" "), (!item.isCancel) ? _c('p', [_vm._v(_vm._s(item.focus.day) + "关注他")]) : _vm._e(), _vm._v(" "), (item.isCancel) ? _c('p', [_vm._v("刚刚取消关注了他")]) : _vm._e(), _vm._v(" "), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!item.isCancel),
        expression: "!item.isCancel"
      }]
    }, [(item.each_other == 1) ? _c('span', [_c('span', {
      staticClass: "icon"
    }), _vm._v("\n              互相关注，\n            ")]) : _vm._e(), _vm._v(" "), (item.each_other == 0) ? _c('span', [_c('span', {
      staticClass: "icon focused"
    }), _vm._v("\n              已关注\n            ")]) : _vm._e(), _vm._v(" "), _c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.doCancel(item)
        }
      }
    }, [_vm._v("取消")]), _vm._v(" "), _c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.showBox(item.user_id, item.nick_name)
        }
      }
    }, [_vm._v("留言")])]), _vm._v(" "), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.isCancel),
        expression: "item.isCancel"
      }]
    }, [_c('span', {
      staticClass: "follow",
      on: {
        "click": function($event) {
          return _vm.doAdd(item)
        }
      }
    }, [_c('span', {
      staticClass: "icon focus"
    }), _vm._v("\n              关注\n            ")])])])])
  }), 0), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.page.totalPage > 1),
      expression: "page.totalPage > 1"
    }],
    staticClass: "load-more",
    attrs: {
      "type": "button",
      "disabled": _vm.use
    },
    on: {
      "click": _vm.doLoadMore
    }
  }, [_vm._v("\n      " + _vm._s(_vm.load_more) + "\n    ")])]) : _c('div', {
    staticClass: "attention-null"
  }, [_c('img', {
    attrs: {
      "src": require("../../../images/personal_center/work-null.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("未关注任何人，没事多看看帅哥美女吧")])]), _vm._v(" "), (_vm.msgBox.status) ? _c('div', {
    staticClass: "attention-pops"
  }, [_c('div', {
    staticClass: "pops-content"
  }, [_c('div', {
    staticClass: "message"
  }, [_c('h4', [_vm._v("给 "), _c('router-link', {
    staticClass: "user",
    attrs: {
      "to": {
        path: '/s-mart/personal/' + _vm.msgBox.user_id + '/'
      }
    }
  }, [_vm._v(_vm._s(_vm.msgBox.nick_name))]), _vm._v(" 留言"), _c('a', {
    staticClass: "fr pops-close",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.closeBox
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../images/personal_center/pops-close.png"),
      "alt": ""
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "msg-box"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.msg.content),
      expression: "msg.content"
    }],
    staticClass: "msg",
    attrs: {
      "placeholder": "在此输入你的留言内容...",
      "name": "msg",
      "maxlength": "200"
    },
    domProps: {
      "value": (_vm.msg.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.msg, "content", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.msg_list[_vm.msgBox.user_id].status) ? _c('div', {
    staticClass: "send clearfix"
  }, [(200 - _vm.msg.content.length >= 0) ? _c('p', [_vm._v("还可以输入 "), _c('span', {
    staticClass: "number"
  }, [_vm._v(_vm._s(200 - _vm.msg.content.length))]), _vm._v(" 个字符")]) : _c('p', [_vm._v("已超出 "), _c('span', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.msg.content.length - 200))]), _vm._v(" 个字符")]), _vm._v(" "), (!_vm.msg.isSubmit) ? _c('a', {
    staticClass: "send-msg",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.sendMsg
    }
  }, [_vm._v("发送")]) : _c('a', {
    staticClass: "send-msg",
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_c('img', {
    staticClass: "loading",
    attrs: {
      "src": require("../../../images/common/loading_16.svg"),
      "alt": ""
    }
  }), _vm._v("提交中")])]) : _c('div', {
    staticClass: "wait"
  }, [_vm._v("\n          发送留言成功，"), _c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm._f("formatTime")(_vm.curCount.count)))]), _vm._v("后可继续留言\n        ")])])])]) : _vm._e(), _vm._v(" "), _c('v-alert', {
    attrs: {
      "options": _vm.options
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-ccfe11de!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/personal_center/my_attention/attention.vue
// module id = hi+Y
// module chunks = 16